import {Request} from "../../core/request";
import {AuthHeader} from "../../core/token";
import type {
    GetStudentListRequest,
    GetStudentListResponse,
    CreateStudentRequest,
    UpdateStudentRequest,
    ResetStudentPasswordRequest,
    Student
} from "./types";

// 获取学生列表
export async function getStudentList(req: GetStudentListRequest): Promise<GetStudentListResponse> {
    const resp = await Request.get(`/admin_manager/students/`, {
        headers: AuthHeader(),
        params: req,
    });
    return resp.data;
}

// 创建学生
export async function createStudent(req: CreateStudentRequest): Promise<{data: Student}> {
    const resp = await Request.post(`/admin_manager/students/`, req, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 更新学生信息
export async function updateStudent(studentID: number, req: UpdateStudentRequest): Promise<{data: Student}> {
    const resp = await Request.put(`/admin_manager/students/${studentID}`, req, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 重置学生密码
export async function resetStudentPassword(studentID: number, req: ResetStudentPasswordRequest): Promise<{data: string}> {
    const resp = await Request.put(`/admin_manager/students/${studentID}/reset_password`, req, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 禁用学生
export async function disableStudent(studentID: number): Promise<{data: string}> {
    const resp = await Request.put(`/admin_manager/students/${studentID}/disable`, {}, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 删除学生（软删除）
export async function deleteStudent(studentID: number): Promise<{data: string}> {
    const resp = await Request.delete(`/admin_manager/students/${studentID}`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 彻底删除学生（仅已软删除记录）
export async function permanentDeleteStudent(studentID: number): Promise<{data: string}> {
    const resp = await Request.delete(`/admin_manager/students/${studentID}/permanent`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 获取全局学生初始密码
export async function getStudentDefaultInitPassword(): Promise<{data: string}> {
    const resp = await Request.get(`/admin_manager/students/default_init_password`, {
        headers: AuthHeader(),
    });
    return resp.data;
}

// 设置全局学生初始密码（超级管理员）
export async function setStudentDefaultInitPassword(defaultInitPassword: string): Promise<{data: string}> {
    const resp = await Request.put(`/super_admin/system/student_default_init_password`, {
        default_init_password: defaultInitPassword,
    }, {
        headers: AuthHeader(),
    });
    return resp.data;
}
